import { AdminPanelBodyProps } from './admin-panel-body-props';
import styled from 'styled-components';

const getPadding = (props: AdminPanelBodyProps) => {
  switch (props.padding) {
    case 'none':
      return '0';
    case 'narrow':
      return '0 0.5rem';
    case 'full':
    default:
      return '0 1rem';
  }
};

export const AdminPanelBody = styled.div<AdminPanelBodyProps>`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${getPadding};
  margin-bottom: 1rem;
`;
